<forge-card class="chart" no-padding [fxShow]="!hidden">
  <forge-toolbar attr.slot="header">
    <div slot="start" fxLayout="column">
      <h2 class="forge-typography--heading4">Percent of Open Enrollment Completed</h2>
    </div>
  </forge-toolbar>

  <div class="metadata-padding">
    @if (hasDataCompleteCard) {
      @for (data of data; track data) {
        <div>
          <open-enrollment-complete-chart [data]="data" (drillIn)="drillIn()" [index]="$index">
          </open-enrollment-complete-chart>
        </div>
      }
    }

    @if (chartLoading) {
      <busy-indicator chart="true"></busy-indicator>
    }

    <div [fxShow]="!chartLoading && !ChartHasData">Not enough data to display graph</div>
  </div>
</forge-card>